import React, { useEffect, useState } from 'react';
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaCopy, FaCheck } from 'react-icons/fa';
import { ContaServico } from '../../../viewmodel/ContaServicoViewModel';
import UsuarioViewModel from '../../../viewmodel/usuario/UsuarioViewModel';
import Usuario from '../../../model/Usuario/Usuario';
import useUnidadeStore from '../../../stores/unidadeStore';

type Props = {
  conta: ContaServico;
  onClose: () => void;
};

const AtivacaoContaModal: React.FC<Props> = ({ conta, onClose }) => {
  const [copied, setCopied] = useState(false);
  const [responsavel, setResponsavel] = useState<Usuario | null>(null);
  const { unidades, fetchUnidades } = useUnidadeStore();
  const unidade = unidades.find(u => u.id === conta.unidadeId);

  const handleCopy = () => {
    navigator.clipboard.writeText(`
    Olá. 
      A Administração de TI do Sistema Identifica solicita a criação de uma Conta de Serviço, 
      com a seguinte formatação:
        
        1. Criar um "client", para o cliente "Identifica", do ambiente de "PRODUÇÃO"
        2. Definir o fluxo oAuth como "client credentials"
        3. Usar como "client_id" da conta: ${conta.clientId}
        4. Usar como "name" da conta: identifica-${unidade?.nome || "NOME_DA_UNIDADE"}-integ
        5. Repassar client_id + secret (confidenciais) para o email do responsável: ${responsavel?.email}
    `);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const fetchResponsavel = async (responsavelId: string) => {
    try {
      const usuario = await UsuarioViewModel.getUsuario(responsavelId);
      setResponsavel(usuario || null);
    } catch (error) {
      console.error('Erro ao buscar responsável:', error);
    }
  };

  useEffect(() => {
    fetchUnidades();
    if (conta.responsavelId) {
      fetchResponsavel(conta.responsavelId);
    }
  }, [conta.responsavelId, fetchUnidades]);

  return (
    <Modal show onHide={onClose} size='xl'>
      <Modal.Header closeButton>
        <Modal.Title>Ativação da Conta de Serviço</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          Para a ativação desta Conta de Serviço, deve-se fazer abrir um chamado para a equipe da Autenticação Central da Unicamp em:
        </div>
        
        <div className="d-flex align-items-center bg-light p-2 rounded mb-3">
          <a 
            href="https://unicamp-agil.atlassian.net/servicedesk/customer/portal/16/group/76/create/209" 
            target="_blank" 
            rel="noopener noreferrer"
            className="mb-0 flex-grow-1"
            style={{ overflowX: 'auto', textDecoration: 'none' }}
          >
            https://unicamp-agil.atlassian.net/servicedesk/customer/portal/16/group/76/create/209
          </a>
        </div>

        <div className="mb-3">
          Com requisição de criação de Conta de Serviço (Cliente) para o <strong>Identifica</strong> com as seguintes instruções:
        </div>

        <div className="d-flex align-items-center bg-light p-2 rounded mb-3">
          <pre className="mb-0 flex-grow-1" style={{ overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
            Olá.<br />
            A Administração de TI do Sistema Identifica solicita a criação de uma Conta de Serviço,<br />
            com a seguinte formatação:<br /><br />
            1. Criar um "client", no Cliente "Identifica", do ambiente de "PRODUÇÃO"<br />
            2. Definir o fluxo oAuth como "client credentials"<br />
            3. Usar como "client_id" da conta: {conta.clientId}<br />
            4. Repassar client_id + secret (confidenciais) para o email do responsável: {responsavel?.email}
          </pre>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{copied ? 'Copiado!' : 'Copiar para área de transferência'}</Tooltip>}
          >
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={handleCopy}
              className="ms-2"
            >
              {copied ? <FaCheck className="text-success" /> : <FaCopy />}
            </Button>
          </OverlayTrigger>
        </div>

        <div className="mt-3">
          A equipe da Autenticação Central deverá repassar o <strong>secret</strong> para o responsável, conforme o pedido, com isso ele já poderá acessar o sistema.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AtivacaoContaModal;